import React from 'react';
import PropTypes from 'prop-types';
import '../App.css';

export default function SearchBar({ value, onChange, onResetFilters, onResetGreyed }) {
  return (
    <>
      <style>{`
        .fl-search-input {
          background: rgba(14,17,23,0.7);
          border: 1px solid rgba(255,255,255,0.25);
          border-radius: 6px;
          color: #ffffff;
          font-family: 'Georgia', serif;
          font-size: 0.88rem;
          padding: 0.5rem 2rem 0.5rem 2.2rem;
          outline: none;
          width: 240px;
          transition: border-color 0.2s, background 0.2s;
          letter-spacing: 0.02em;
        }
        .fl-search-input::placeholder { color: rgba(255,255,255,0.2); }
        .fl-search-input:focus {
          border-color: rgba(255,255,255,0.55);
          background: rgba(26,35,64,0.8);
        }
        .fl-search-wrap {
          position: relative;
          display: inline-flex;
          align-items: center;
        }
        .fl-search-icon {
          position: absolute;
          left: 0.65rem;
          color:  #ffffff;
          pointer-events: none;
          font-size: 0.9rem;
          line-height: 1;
        }
        .fl-search-clear {
          position: absolute;
          right: 0.5rem;
          background: none;
          border: none;
          color: #40382e;
          cursor: pointer;
          font-size: 1rem;
          line-height: 1;
          padding: 0;
          transition: color 0.15s;
        }
        .fl-search-clear:hover { color: #c8a84b; }
        .fl-btn-reset:hover {
          border-color: rgba(200,168,75,0.5) !important;
          color: #f0d060 !important;
          background: rgba(200,168,75,0.08) !important;
        }
        .fl-btn-restart:hover {
          border-color: rgba(200,100,100,0.5) !important;
          color: #f08080 !important;
          background: rgba(200,80,80,0.08) !important;
        }
      `}</style>

      <div style={S.container}>
        {/* Search with icon + inline clear */}
        <div className="fl-search-wrap">
          <span className="fl-search-icon">⌕</span>
          <input
            className="fl-search-input"
            type="text"
            placeholder="Search Pokémon…"
            value={value}
            onChange={e => onChange(e.target.value)}
          />
          {value && (
            <button className="fl-search-clear" onClick={() => onChange('')} title="Clear">×</button>
          )}
        </div>

        <div style={S.divider} />

        <button className="fl-btn-reset" onClick={onResetFilters} style={S.btnReset} title="Clear type filters">
          Reset Filters
        </button>

        <button className="fl-btn-restart" onClick={onResetGreyed} style={S.btnRestart} title="Restart run — clears all teams and greyed Pokémon">
          ↺ Restart
        </button>
      </div>
    </>
  );
}

const S = {
  container: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    flexWrap: 'wrap',
    justifyContent: 'center',
  },
  divider: {
    width: '1px',
    height: '1.4rem',
    background: 'rgba(200,168,75,0.12)',
    margin: '0 0.15rem',
  },
  btnReset: {
    padding: '0.45rem 0.9rem',
    borderRadius: '6px',
    border: '1px solid rgba(200,168,75,0.2)',
    background: 'transparent',
    color: '#6a5040',
    fontSize: '0.75rem',
    fontWeight: 700,
    cursor: 'pointer',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontFamily: "'Georgia', serif",
    transition: 'all 0.2s ease',
  },
  btnRestart: {
    padding: '0.45rem 0.9rem',
    borderRadius: '6px',
    border: '1px solid rgba(160,60,60,0.25)',
    background: 'transparent',
    color: '#6a3030',
    fontSize: '0.75rem',
    fontWeight: 700,
    cursor: 'pointer',
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    fontFamily: "'Georgia', serif",
    transition: 'all 0.2s ease',
  },
};

SearchBar.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  onResetFilters: PropTypes.func.isRequired,
  onResetGreyed: PropTypes.func.isRequired,
};